/**
 * @copyright 2026 @ DigiNet
 * @author YENNHI
 * @create 2026/07/14 08:37
 * @update 2026/07/14 08:37
 */

import { Column, Summary, TotalItem } from "devextreme-react/data-grid";
import { Col, DatePicker, Dropdown, Row, Typography, Label, Button, Checkbox, TextInput, NumberInput } from 'diginet-core-ui/components';
import React, { useEffect, useMemo, useState, useRef } from 'react';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as userActions from "../../../actions/user-actions";
import * as W07F6699Actions from "../../../actions/w07/W07F6699/W07F6699-actions";
import Config from "../../../config";
import GridContainer from "../../common/grid-container/grid-container";
import ActionToolbar from "../../common/tool-bar/action-toolbar";
import { useTheme, makeStyles } from "diginet-core-ui/theme";
import MForm from "../../common/form/form";
const { colors } = useTheme();

const useStyles = makeStyles({
    moneyInputColumn: {
        width: '100%',
        margin: 0,
        '& input': {
            textAlign: 'right'
        }
    },
});

const FormID = 'W07F6699';
const requiredField = ['ReportID'];

const W07F6699 = (props) => {
    const classes = useStyles();
    const [iPermission, setIPermission] = useState(null);
    const [formLoading, setFormLoading] = useState(false);
    const [gridLoading, setGridLoading] = useState(false);
    const [cboDropwDownLoading, setCboDropwDownLoading] = useState(false);
    const [openFilter, setOpenFilter] = useState(false);
    const [dataFilter, setDataFilter] = useState({
        ReportID: "",
        ReportName: "",
        IsDate: 1,
        DateFrom: Config.convertDate(new Date(), "", "MM/DD/YYYY"),
        DateTo: Config.convertDate(new Date(), "", "MM/DD/YYYY"),
        IsPeriod: 0,
        PeriodFrom: "",
        PeriodTo: "",
        WareHouseID: "",
        WareHouseName: "",
        TxtInvID: ""
    });
    const [dataGrid, setDataGrid] = useState([]);
    const [dataCboDropDown, setCboDropDown] = useState({});
    const [dataCboAddcol, setCboAddcol] = useState({});
    const [error, setError] = useState({});

    const gridContainer = useRef([]);

    useEffect(() => {
        loadPermission();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (!iPermission) return;
        loadCboDropDown('CmbReport', (ReportID) => {
            if (ReportID) {
                loadAddCol(ReportID);
                loadGrid(ReportID);
            }
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [iPermission]);

    const loadPermission = () => {
        props.userActions.getPermission(Config.profile.UserID, FormID, (iPer) => {
            setIPermission(iPer)
        });
    };

    const onExporting = (e) => {
        const now = new Date();
        const dateExport = `${now.getDate()}-${now.getMonth() + 1}-${now.getFullYear()}_${now.getHours()}h${now.getMinutes()}p`;
        e.fileName = `${dataFilter?.ReportName || Config.lang("Bao_cao_ton_kho")}_${dateExport}`;
    };

    const exportExcel = async () => {
        if (!require() || Config.isEmpty(dataFilter?.ReportID)) return;
        const grid = gridContainer.current.instance;
        const dataSource = grid.option("dataSource");

        if (!dataSource || dataSource.length === 0) {
            Config.popupCore.show('WARNING', Config.lang("No_data"));
            return;
        }
        grid.exportToExcel(false);
        Config.notify.show(
            "success",
            Config.lang("Xuat_du_lieu_thanh_cong"),
            3000
        );
    };

    const loadGrid = (reportID) => {
        const params = getParamGeneral('LoadForm', { ReportID: reportID });
        setGridLoading(true);
        props.W07F6699Actions.loadGrid(params, (error, data) => {
            setGridLoading(false);
            if (error) {
                Config.popupCore.show('ERROR', error);
                return false;
            } else if (data) {
                setDataGrid(data || []);
            }
        });
    };

    const getDataType = (type) => {
        const value = type?.toLowerCase() || "";
        if (value.includes("date")) return "date";
        if (value.includes("int") || value.includes("decimal") || value.includes("numeric")) return "number";
        if (value.includes("bit")) return "boolean";
        return "string";
    };

    const getDecimalPlace = (type) => {
        const match = type?.match(/(?:decimal|numeric)\(\d+,\s*(\d+)\)/i);
        return match ? Number(match[1]) : 0;
    };

    const renderColDataType = (dataType, decimal) => {
        let colProps = {};
        if (dataType === "number" && decimal > 0) {
            colProps = {
                dataType: 'number',
                alignment: 'right',
                width: 200,
                cellRender: (e) => <NumberInput
                    readOnly
                    nonStyle
                    disabledNegative
                    decimalDigit={decimal}
                    thousandSeparator={','}
                    value={e?.value}
                    className={classes.moneyInputColumn}
                />
            };

        } else if (dataType === "date") {
            colProps = {
                alignment: 'center',
                dataType: 'date',
                format: 'dd/MM/yyyy'
            };
        }
        else if (dataType === "number") {
            colProps = {
                alignment: 'right',
                dataType: 'number',
            };
        }
        return colProps;
    }

    const loadAddCol = (reportID) => {
        const params = getParamGeneral('addcol', { ReportID: reportID });
        setFormLoading(true);
        props.W07F6699Actions.loadGrid(params, (error, data) => {
            setFormLoading(false);
            if (error) {
                Config.popupCore.show('ERROR', error);
                return false;
            } else if (data) {
                const arrCol = [];
                const arrColCal = [];
                for (let i = 0; i < data.length; i++) {
                    const col = {
                        caption: data[i]?.Caption,
                        dataField: data[i]?.FieldName,
                        dataType: getDataType(data[i]?.Datatype),
                        isSumfooter: data[i]?.IsSumfooter,
                        decimalPlace: getDecimalPlace(data[i]?.Datatype),
                    };
                    const dataTypeCell = renderColDataType(col.dataType, col.decimalPlace);
                    arrCol.push(<Column
                        key={col.dataField}
                        dataField={col.dataField}
                        caption={col.caption}
                        dataType={col.dataType}
                        {...dataTypeCell}
                    />)
                    if (col.isSumfooter === 1) arrColCal.push(<TotalItem
                        key={col.dataField}
                        column={col.dataField}
                        summaryType={'sum'}
                        displayFormat={"{0}"}
                        valueFormat={(e) => Config.numberFormat(e, col.decimalPlace)}
                    />)
                }
                setCboAddcol({
                    arrCol, arrColCal
                });
            }
        });
    };

    const loadCboDropDown = (dataType, cb) => {
        const params = getParamGeneral(dataType);
        setCboDropwDownLoading(true);
        props.W07F6699Actions.loadGrid(params, (error, data) => {
            setCboDropwDownLoading(false);
            if (error) {
                Config.popupCore.show('ERROR', error);
                return false;
            } else if (data) {
                let ReportID = '';
                if (dataType === "CmbReport") {
                    ReportID = data?.[0]?.ReportID || '';
                    setDataFilter({ ...dataFilter, ReportID }); // default
                }
                setCboDropDown(prev => ({
                    ...prev,
                    [dataType]: data || []
                }));
                if (dataType === 'CmbReport' && cb) {
                    cb(ReportID);
                }
            }
        });
    };

    const dataSourceDropDown = (dataType) => {
        return dataCboDropDown[dataType] || [];
    };

    const onOpenLoaded = () => {
        loadCboDropDown('CmbWareHouse');
        loadCboDropDown('CmbPeriodF');
        loadCboDropDown('CmbPeriodT');

        const grid = gridContainer.current?.instance;
        if (grid) {
            grid.option("onExporting", onExporting);
        }
    };

    const getParamGeneral = (type, data = {}) => {
        const { ReportID = "", IsDate, DateFrom = null, DateTo = null, IsPeriod, PeriodFrom = null, PeriodTo = null, WareHouseID = "", TxtInvID = "" } = dataFilter;
        let params = {
            DataType: type,
            ReportID: data?.ReportID || ReportID,
            IsDate,
            DateFrom,
            DateTo,
            IsPeriod,
            PeriodFrom,
            PeriodTo,
            WareHouseID,
            TxtINVID: TxtInvID,
        };
        return params;
    };

    const btnCRM = [
        {
            buttonName: Config.lang("Xuat_du_lieu"),
            buttonType: 'button',
            icon: 'Sheet',
            color: 'Success',
            align: 'right',
            disabled: false,
            onClick: () => exportExcel()
        }];

    const checkValidateMaster = (arrName) => {
        if (Config.isEmpty(arrName)) return;
        return arrName.map(item => {
            let val = dataFilter[item];
            return {
                name: item,
                rules: ["isRequired"],
                value: val
            }
        });
    };

    const require = () => {
        const resultValidate = checkValidateMaster(requiredField);
        const validateFrom = MForm.formValidation(resultValidate);
        if (Object.keys(validateFrom).length > 0) {
            setError(validateFrom, true);
            return false;
        }
        return true;
    }

    const onSearch = () => {
        if (!require() || Config.isEmpty(dataFilter?.ReportID)) return;
        loadGrid();
        loadAddCol();
    };
   
    const onChangeFilter = (keyName, e) => {
        if (!e || !keyName) return;
        let value;
        if (['IsDate', 'IsPeriod'].includes(keyName)) {
            const checked = e?.target?.checked ?? e?.checked ?? e?.value ?? e;
            value = checked ? 1 : 0;
        } else value = e?.value ?? e?.target?.value ?? '';
        if (Config.isEmpty(value) && ['DateFrom', 'DateTo'].includes(keyName)) value = null;
        let objPlus = {
            ...dataFilter,
            [keyName]: value,
        };
        switch (keyName) {
            case "ReportID":
                objPlus.ReportName = e?.data?.ReportName
                break;
            case "IsDate":
                if (value === 1) {
                    objPlus.IsPeriod = 0;
                } else {
                    objPlus.IsPeriod = 1;
                }
                break;
            case "IsPeriod":
                if (value === 1) {
                    objPlus.IsDate = 0;
                } else {
                    objPlus.IsDate = 1;
                }
                break;
            case "WareHouseID":
                objPlus.WareHouseName = e?.data?.WareHouseName
                break;
            default:
                break;
        }
        setDataFilter(objPlus);
        if (!Config.isEmpty(value) && error?.[keyName]) setError({ ...error, [keyName]: '' });
    };

    const filterRender = () => {
        return <Row>
            <Col xs={12} sm={12} md={6} lg={6}>
                <Row>
                    <Col xs={12} sm={6}>
                        <Row>
                            <Col xs={12} sm={4} className={'pdl0'} verticalAlign={"center"} >
                                <Checkbox
                                    className="mgl4x"
                                    label={Config.lang('Ngay')}
                                    labelProps={{ type: "h4", color: colors.text.label }}
                                    checked={Number(dataFilter?.IsDate) === 1}
                                    onChange={(e) => onChangeFilter("IsDate", e)}
                                />
                            </Col>
                            <Col xs={12} sm={8}>
                                <DatePicker
                                    clearAble
                                    viewType={'outlined'}
                                    displayFormat={"DD/MM/YYYY"}
                                    disabled={dataFilter?.IsDate !== 1}
                                    placeholder={Config.lang('Tu')}
                                    max={dataFilter?.DateTo}
                                    value={dataFilter?.DateFrom}
                                    className={'full_w'}
                                    onChange={e => onChangeFilter('DateFrom', e)}
                                />
                            </Col>
                        </Row>
                    </Col>
                    <Col xs={12} sm={6}>
                        <Row className={"display_row align-center"}>
                            <Col xs={12} sm={2} className={"pdl0 display_row valign-middle"}>
                                <Typography className="mgr1x" type='p1' color={colors.text.label} style={{ whiteSpace: 'nowrap' }}>-</Typography>
                            </Col>
                            <Col xs={12} sm={10} className={'pdl0'}>
                                <DatePicker
                                    clearAble
                                    viewType={'outlined'}
                                    displayFormat={"DD/MM/YYYY"}
                                    disabled={dataFilter?.IsDate !== 1}
                                    placeholder={Config.lang('Den')}
                                    min={dataFilter?.DateFrom}
                                    value={dataFilter?.DateTo}
                                    onChange={e => onChangeFilter('DateTo', e)}
                                />
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Col>
            <Col xs={12} sm={12} md={4} lg={4}>
                <Row className={"display_row align-center"}>
                    <Col xs={12} sm={2}>
                        <Typography className="mgr4x" type='h4' color={colors.text.label} style={{ whiteSpace: 'nowrap' }}>{Config.lang("Kho")}</Typography>
                    </Col>
                    <Col xs={12} sm={10}>
                        <Dropdown
                            style={{backgroundColor: "white"}}
                            viewType={'outlined'}
                            valueExpr={'WareHouseID'}
                            displayExpr={'WareHouseName'}
                            loading={cboDropwDownLoading}
                            dataSource={dataSourceDropDown('CmbWareHouse')}
                            value={dataFilter?.WareHouseID}
                            onChange={e => onChangeFilter('WareHouseID', e)}
                        />
                    </Col>
                </Row>
            </Col>

            <Col xs={12} sm={12} md={6} lg={6}>
                <Row>
                    <Col xs={12} sm={6}>
                        <Row>
                            <Col xs={12} sm={4} className={'pdl0'} verticalAlign={"center"} >
                                <Checkbox
                                    className="mgl4x"
                                    label={Config.lang('Ky')}
                                    labelProps={{ type: "h4", color: colors.text.label }}
                                    checked={Number(dataFilter?.IsPeriod) === 1}
                                    onChange={(e) => onChangeFilter("IsPeriod", e)}
                                />
                            </Col>
                            <Col xs={12} sm={8}>
                                <Dropdown
                                    style={{backgroundColor: "white"}}
                                    viewType={'outlined'}
                                    valueExpr={'PeriodFrom'}
                                    displayExpr={'PeriodName'}
                                    loading={cboDropwDownLoading}
                                    disabled={dataFilter?.IsPeriod !== 1}
                                    dataSource={dataSourceDropDown('CmbPeriodF')}
                                    placeholder={Config.lang('Tu')}
                                    value={dataFilter?.PeriodFrom}
                                    className={'full_w'}
                                    onChange={e => onChangeFilter('PeriodFrom', e)}
                                />
                            </Col>
                        </Row>
                    </Col>
                    <Col xs={12} sm={6}>
                        <Row className={"display_row align-center"}>
                            <Col xs={12} sm={2} className={"pdl0 display_row valign-middle"}>
                                <Typography className="mgr1x" type='p1' color={colors.text.label} style={{ whiteSpace: 'nowrap' }}>-</Typography>
                            </Col>
                            <Col xs={12} sm={10} className={"pdl0"}>
                                <Dropdown
                                    style={{backgroundColor: "white"}}
                                    viewType={'outlined'}
                                    valueExpr={'PeriodTo'}
                                    displayExpr={'PeriodName'}
                                    loading={cboDropwDownLoading}
                                    disabled={dataFilter?.IsPeriod !== 1}
                                    dataSource={dataSourceDropDown('CmbPeriodT')}
                                    placeholder={Config.lang('Den')}
                                    value={dataFilter?.PeriodTo}
                                    onChange={e => onChangeFilter('PeriodTo', e)}
                                />
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Col>
            <Col xs={12} sm={12} md={4} lg={4}>
                <Row className={"display_row align-center"}>
                    <Col xs={12} sm={2}>
                        <Typography className="mgr4x" type='h4' color={colors.text.label} style={{ whiteSpace: 'nowrap' }}>{Config.lang("Ma_hang")}</Typography>
                    </Col>
                    <Col xs={12} sm={10}>
                        <TextInput
                            label={Config.lang("")}
                            viewType={'outlined'}
                            value={dataFilter?.TxtInvID}
                            onChange={e => onChangeFilter('TxtInvID', e)}
                        />
                    </Col>
                </Row>
            </Col>
            <Col xs={12} sm={12} md={2} lg={2} className={'display_row valign-bottom'} verticalAlign={'end'}>
                <Button
                    style={{backgroundColor: "white"}}
                    startIcon={"Search"}
                    viewType={"outlined"}
                    label={Config.lang("Tim_kiem")}
                    onClick={onSearch}
                />
            </Col>
        </Row>
    };

    const onOpenFilter = (status) => {
        setOpenFilter(status);
    };

    const renderGrid = useMemo(() => {
        return (
            <GridContainer
                isShowFilter
                reference={(ref) => gridContainer.current = ref}
                dataSource={dataGrid}
                isPer={iPermission}
                buttonCRM={btnCRM}
                loading={formLoading || gridLoading}
                typePaging={'normal'}
                keyExpr={'VoucherNo'}
                pagerFullScreen
                itemPerPage={80}
                onOpenFilter={onOpenFilter}
                elementAttr={{ style: `height: ${openFilter ? Config.getHeightGrid() - 222 : Config.getHeightGrid() - 86}px; max-height: ${openFilter ? '' : '830px'}` }}
                listPerPage={[80, 160, 240, 320]}
                filterRender={filterRender()}
                onSearch={onSearch}
                showSearchInput={false}
                onOpenLoaded={onOpenLoaded}
            >
                {dataCboAddcol?.arrCol && dataCboAddcol.arrCol}
                <Summary>
                    {dataCboAddcol?.arrColCal && dataCboAddcol.arrColCal}
                </Summary>
            </GridContainer>
        )
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [iPermission, dataGrid, formLoading, cboDropwDownLoading, dataCboAddcol, dataSourceDropDown, dataFilter, gridLoading]);

    if (!iPermission) return null;

    return (
        <div className={'page-container'} style={{ height: '100vh' }}>
            <ActionToolbar title={Config.lang("Bao_cao_ton_kho")} >
                <Row>
                    <Col xs={12} className={"display_row align-center valign-bottom"}>
                        <Label required style={{ whiteSpace: 'nowrap' }}>{Config.lang('Mau_bao_cao')}</Label>
                        <Dropdown
                            required
                            clearAble
                            className={'mgl4x'}
                            viewType={'outlined'}
                            valueExpr={'ReportID'}
                            displayExpr={'ReportName'}
                            loading={cboDropwDownLoading}
                            dataSource={dataSourceDropDown('CmbReport')}
                            value={dataFilter?.ReportID}
                            error={error?.ReportID}
                            style={{ minWidth: 200 }}
                            onChange={e => onChangeFilter('ReportID', e)}
                        />
                    </Col>
                </Row>
            </ActionToolbar>
            <Row><Col xs={12}>{renderGrid}</Col></Row>
        </div>
    );
}

export default connect(null, (dispatch) => ({
    W07F6699Actions: bindActionCreators(W07F6699Actions, dispatch),
    userActions: bindActionCreators(userActions, dispatch),
}))(W07F6699);